/*
 *   File : change-password.js
 *   Author : https://evoqins.com
 *   Description : Change password modal component
 *   Integrations : NA
 *   Version : 1.0.0
*/

// custom packages
import React, { useEffect, useState } from 'react';
import { Modal } from 'bootstrap/dist/js/bootstrap.min';
import { toast } from 'react-toastify';

// custom components
import { CustomTextInput } from '../FormElements';
import { Icon } from '../Icon';
import { PrimaryButton } from '../Buttons';
import ConfirmModal from './confirm';
import { APIService } from '../../Service';

// custom style
import Color from "../../Style/color.scss";
import style from "../../Style/Component/modal.module.scss";


const ChangePasswordModal = (props) => {

    const [password, setPassword] = useState("");
    const [passwordError, setPasswordError] = useState("");
    const [newPassword, setNewPassword] = useState("");
    const [newPasswordError, setNewPasswordError] = useState("");
    const [confirmNewPassword, setConfirmNewPassword] = useState("");
    const [confirmNewPasswordError, setConfirmNewPasswordError] = useState("");
    const [successModal, setSuccessModal] = useState(false);


    useEffect(() => {
        setPasswordError("");
    }, [password]);

    useEffect(() => {
        setNewPasswordError("");
    }, [newPassword]);

    useEffect(() => {
        setConfirmNewPasswordError("");
    }, [confirmNewPassword]);

    useEffect(() => {
        if (successModal === true) {
            const success_modal = new Modal(document.getElementById("confirm-modal"));
            success_modal.show();

        }
    }, [successModal])


    const _handleCloseModal = () => {
        var button = document.getElementById("menu-modal");
        button.click();
        props.handleClose();
    };

    // handle  save
    const _handleSave = () => {

        let is_valid = true;
        let validate_new_password = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/;


        if (password.trim().length === 0) {
            setPasswordError("Please provide current password");
            is_valid = false
        }

        if (newPassword.trim().length === 0) {
            setNewPasswordError("Please provide new password");
        } else if (!validate_new_password.test(newPassword)) {
            setNewPasswordError("Please provide a valid password");
            is_valid = false
        }

        if (confirmNewPassword.trim().length === 0) {
            setConfirmNewPasswordError("Re-enter the password");
        } else if (newPassword !== confirmNewPassword) {
            setConfirmNewPasswordError("Password do not match");
            is_valid = false
        }

        if (is_valid === true) {
            _changePassword();

        }
    };

    // handle change password
    const _changePassword = () => {
        let is_post = true;
        let url = "auth/change-password";
        let request = {
            "current_password": password,
            "new_password": confirmNewPassword
        }
        APIService(is_post, url, request).then((response) => {
            if (response.status_code === 200) {
                document.getElementById("close-btn").dispatchEvent(new Event("click"));
                setTimeout(() => {
                    setSuccessModal(true);
                }, 200);
            } else {
                toast.dismiss();
                toast.success(response.message, { type: "error" })
            }
        })
    };

    return (
        <>
            <div className="modal fade"
                id="menu-modal"
                data-bs-backdrop="static"
                data-bs-keyboard="false"
                tabIndex="-1"
                aria-labelledby="ChangePasswordModalLabel"
                aria-hidden="true">

                <div className={`modal-lg modal-dialog modal-dialog-centered justify-content-center modal-dialog-scrollable border-radius-28`}>

                    <div className={`${style.e_change_password_modal} modal-content border-radius-28 overflow-hidden border-0 e-bg-white-dark`}>

                        {/* modal header */}
                        <div className="modal-header border-0 justify-content-between align-items-center padding-32px-lr padding-32px-top pb-4">
                            <h6 className='mb-0 e-text-chinese-black e-primary-font e-font-16 e-font-weight-600 line-height-24px'>
                                Change password
                            </h6>
                            <Icon icon='close'
                                size="1.125rem"
                                data-bs-dismiss="modal"
                                id="close-btn"
                                onClick={_handleCloseModal}
                                className="d-flex cursor-pointer" />
                        </div>

                        {/* Modal body */}
                        <div className='modal-body pt-0 padding-32px-lr padding-32px-bottom'>

                            <>
                                <div className='row '>
                                    {/* Current Password */}
                                    <div className='col-12 pb-3'>
                                        <CustomTextInput label="Current password"
                                            placeholder="Enter current password"
                                            type="text"
                                            autoFocus={true}
                                            required={true}
                                            value={password}
                                            error={passwordError}
                                            className="w-100"
                                            inputType={2}
                                            onKeyPress={_handleSave}
                                            handleChange={(e) => setPassword(e)} />
                                    </div>

                                    {/* New Password */}
                                    <div className='col-12 pb-3'>
                                        <CustomTextInput label="New password"
                                            placeholder="Enter New password"
                                            type="text"
                                            autoFocus={true}
                                            required={true}
                                            value={newPassword}
                                            error={newPasswordError}
                                            className="w-100"
                                            inputType={2}
                                            onKeyPress={_handleSave}
                                            handleChange={(e) => setNewPassword(e)} />
                                    </div>

                                    {/* Confirm New Password */}
                                    <div className='col-12 pb-4'>
                                        <CustomTextInput label="Confirm new password"
                                            placeholder="Confirm new password"
                                            type="text"
                                            autoFocus={true}
                                            required={true}
                                            value={confirmNewPassword}
                                            error={confirmNewPasswordError}
                                            className="w-100"
                                            inputType={2}
                                            onKeyPress={_handleSave}
                                            handleChange={(e) => setConfirmNewPassword(e)} />
                                    </div>


                                </div>



                                <div className=' e-bg-magnolia-light p-3 border-radius-8 d-flex gap-1 align-items-start'>
                                    <Icon icon="info"
                                        size="1rem"
                                        color={Color.davys_grey_light}
                                        className="d-flex" />

                                    <p className='mb-0 e-text-davys-grey-light e-primary-font e-font-14 e-font-weight-400 line-height-18px'>
                                        Your new password must be at least 8 characters long. It should include a mix of uppercase and lowercase letters, numbers, and special characters.
                                    </p>
                                </div>
                            </>

                        </div>

                        {/* Modal footer */}
                        <div className=' modal-footer border-0 pt-0 padding-32px-lr padding-32px-bottom gap-4'>
                            <>
                                <PrimaryButton name="Save"
                                    className="w-100 m-0"
                                    onClick={_handleSave} />
                            </>

                        </div>
                    </div>
                </div>
            </div>


            {
                successModal === true && (
                    <ConfirmModal title='Success!'
                        description='Your password has been updated successfully. You will need to use your new password the next time you log in.'
                        status={true}
                        handleClose={() => {
                            setSuccessModal(false);
                            window.location.href = "/"
                        }}
                        handleSuccess={() => {
                            setSuccessModal(false);
                            window.location.href = "/"
                        }}
                    />
                )
            }
        </>

    )
}

export default ChangePasswordModal;

ChangePasswordModal.defaultProps = {
    handleClose: () => { }
};